import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { HelmetProvider } from 'react-helmet-async';
export function AppRouter() {
  return <HelmetProvider data-id="element-17">
      <BrowserRouter data-id="element-18">
        <Routes data-id="element-19">
          <Route path="/" element={<App data-id="element-21" />} data-id="element-20" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-23" />} data-id="element-22" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}